import React, { FC } from 'react';

import { ReactComponent as DiagonalArrow } from 'assets/icons/DiagonalArrow.svg';
import { ReactComponent as PaperPlane } from 'assets/icons/PaperPlane.svg';
import { ReactComponent as PlusSmallIcon } from 'assets/icons/PlusSmall.svg';

import { CardSchema, MessageType } from 'constants/graphqlTypes';
import IconCircle from 'components/UI/IconCircle';
import useOpenModal from 'helpers/useOpenModal';

import { ROUTE_ADD_TO_LIST, ROUTE_NICE_FIND, ROUTE_SELECT_CHAT_MODAL } from 'routes';

import { StyledLink, StyledList } from './DetailMenu/styled';

interface IUserPickDetailMenuProps {
  card: CardSchema;
}

const UserPickDetailMenu: FC<IUserPickDetailMenuProps> = ({ card }) => {
  const { id: pickId, cardId, externalSources, isPickedByMe, isSavedByMe, parentCards } = card;

  const { sourceUrl, sourceDomainName } = externalSources?.items?.[0] ?? {};
  const listCardId = parentCards?.items?.[0]?.cardId;

  const goToNiceFind = useOpenModal(ROUTE_NICE_FIND, false, {
    pickId,
    cardId,
    card,
    cardImage: card.cardStyle?.thumbnailImageSet?.images?.[0]?.url ?? undefined,
    cardColorValue: card.cardStyle?.bgColor?.colorValue,
    sourceUrl: sourceUrl || undefined,
    sourceDomainName: sourceDomainName || undefined,
  });

  const goToPickFlow = useOpenModal(ROUTE_ADD_TO_LIST, false, {
    pickId,
    cardId,
    isPickFlow: true,
    listId: listCardId,
    isPrivateList: false,
  });

  const goToChatSelect = useOpenModal(ROUTE_SELECT_CHAT_MODAL, false, {
    entityId: pickId,
    messageType: MessageType.Pick,
    collectionId: null,
  });

  const handlePick = () => {
    if (!pickId || !cardId) return;

    // For saved picks that aren't picked yet, convert them to picks
    if (isSavedByMe && !isPickedByMe) {
      goToPickFlow();
    } else {
      // Allow picking (or re-picking) via Nice Find flow
      // Backend will create a new pick even if user has already picked this card
      goToNiceFind();
    }
  };

  const handleShare = () => {
    if (!pickId) return;
    goToChatSelect();
  };

  return (
    <StyledList isHidden={false} isInFlow>
      <li>
        <IconCircle hasBorder Icon={PlusSmallIcon} isDark handleClick={handlePick} />
      </li>
      {sourceUrl && (
        <li>
          <StyledLink href={sourceUrl} target="_blank" rel="noopener noreferrer">
            Visit
            <DiagonalArrow />
          </StyledLink>
        </li>
      )}
      <li>
        <IconCircle hasBorder Icon={PaperPlane} isDark handleClick={handleShare} />
      </li>
    </StyledList>
  );
};

export default UserPickDetailMenu;
